class InstallPWA {
	context = null
	deferredPrompt = null

	constructor(context) {
		this.context = context
		this.context.$store.dispatch('PUT_STATE_INSTALL', { granted: false, prompt: false, denied: false })
	}

	setup() {
		window.addEventListener('appinstalled', (event) => this.installApp_Handler(event))
		window.addEventListener('beforeinstallprompt', (event) => this.beforeInstallPrompt_Handler(event))
		this.context.$root.$on('install-request', () => this.onRequestInstall_Handler())
	}

	verificState() {
		if (window.matchMedia('(display-mode: standalone)').matches) {
			this.context.$store.dispatch('PUT_STATE_INSTALL', { granted: true, prompt: false })
		}

	}

	beforeInstallPrompt_Handler(event) {
		event.preventDefault()
		this.deferredPrompt = event
		this.context.$store.dispatch('PUT_STATE_INSTALL', { granted: false, prompt: true })
	}

	installApp_Handler(event) {
		this.context.$store.dispatch('PUT_STATE_INSTALL', { granted: true, prompt: false })
	}

	onRequestInstall_Handler() {
		this.request()
	}

	request() {
		this.deferredPrompt.prompt()
		this.deferredPrompt.userChoice
			.then(result => {
				if (result.outcome === 'accepted') {
					this.context.$store.dispatch('PUT_STATE_INSTALL', { granted: true, prompt: false })
				}
				this.deferredPrompt = null
			})
	}
}

export default InstallPWA


// WEBPACK FOOTER //
// ./src/classes/InstallPWA.js